module.exports = __webpack_public_path__ + "img/470a.7699af23.png";